import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/components/LoadingIndicator';
import ChatHeader from './ChatHeader';
import ChatList from './ChatList';
import ChatViewport from './ChatViewport';

export default class ChatPage extends Page {
    oninit(vnode) {
        super.oninit(vnode);

        this.bodyClass = 'App--chat';
    }

    view() {
        return (
            <div className="ChatPage" style={{
                display: 'flex',
                flexDirection: 'row',
                height: 'calc(100vh - var(--header-height))',
                overflow: 'hidden'
            }}>
                <div className="ChatPage-sidebar" style={{
                    width: '255px',
                    flexShrink: '0',
                    borderRight: '1px solid #e8ecf3',
                    overflow: 'hidden'
                }}>
                    <ChatList inPage={true}></ChatList>
                </div>
                <div className="ChatPage-main" style={{
                    flex: '1',
                    minWidth: '0',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <ChatHeader></ChatHeader>
                    {app.chat.chatsLoading
                        ? <LoadingIndicator />
                        : <ChatViewport chatModel={app.chat.getCurrentChat()} />
                    }
                </div>
            </div>
        );
    }

    oncreate(vnode) {
        super.oncreate(vnode);
    }

    onremove(vnode) {
        super.onremove(vnode);
    }
}
